module.exports = __webpack_public_path__ + "static/10-c4949be64faf59be15ee39bd1ab81c71.png";